export function pathWithParams(path: string|null|undefined, params: { [key: string]: string }, hash?: string): string {
    if (!path) {
        return '#';
    }

    return Object.keys(params).reduce((acc, key) => {
        return acc.replace(`:${key}`, encodeURIComponent(params[key]));
    }, path) + (hash ? `#${hash}` : '');
}
